import type { ObjectId } from "@bbj-types/utils";
import type { CreateAction } from "@root/utils/enums/communication";
import { useCallback } from "react";
import { axios } from "./axios";

export interface ISendEmailsBody {
  attachments?: ObjectId[];
  cc?: string[] | undefined;
  recipients: ObjectId[];
  subject: string;
  content: string;
  createAction: CreateAction;
}

export const useSendEmails = () => {
  const [state, execute, cancel] = axios<void, ISendEmailsBody, unknown>(
    {
      url: "/candidates/communication/emails",
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (data: ISendEmailsBody) => {
      return execute({ data });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
